import axiosInstance from "./axiosInstance";

const API_URL = process.env.REACT_APP_API_URL;

const buildArrayParamSerializer = (params) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null && item !== '') {
          query.append(key, item);
        }
      });
      return;
    }
    query.append(key, value);
  });
  return query.toString();
};

export const getPaginatedShiftLogs = async ({
  page = 1,
  pageSize = 25,
  departmentIds,
  userIds,
  startDate,
  endDate,
  completed,
  sortField,
  sortOrder,
} = {}) => {
  const response = await axiosInstance.get(`${API_URL}/shift-logs/paginated`, {
    params: {
      page,
      pageSize,
      departmentIds,
      userIds,
      startDate,
      endDate,
      completed,
      sortField,
      sortOrder,
    },
    paramsSerializer: buildArrayParamSerializer,
  });
  return response.data;
};

// GET all shift logs
export const getShiftLogs = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/shift-logs`);
    return response.data;
  } catch (error) {
    console.error("Error fetching shift logs:", error.response?.data || error);
    throw error;
  }
};

export const getShiftLogDepartments = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/shift-logs/departments`);
    return response.data;
  } catch (error) {
    console.error("Error fetching shift log departments:", error.response?.data || error);
    throw error;
  }
};

export const getDepartmentChildren = async (departmentId) => {
  if (!departmentId) {
    return [];
  }
  try {
    const response = await axiosInstance.get(
      `${API_URL}/shift-logs/departments/${departmentId}/children`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching shift log department descendants:",
      error.response?.data || error,
    );
    throw error;
  }
};

// GET a single shift log
export const getShiftLogById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/shift-logs/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching shift log:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new shift log
export const createShiftLog = async (shiftLogData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/shift-logs`, shiftLogData);
    return response.data;
  } catch (error) {
    console.error("Error creating shift log:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing shift log
export const updateShiftLog = async (id, shiftLogData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/shift-logs/${id}`, shiftLogData);
    return response.data;
  } catch (error) {
    console.error("Error updating shift log:", error.response?.data || error);
    throw error;
  }
};

// DELETE a shift log
export const deleteShiftLog = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/shift-logs/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting shift log:", error.response?.data || error);
    throw error;
  }
};

export const getDowntimeComments = async (eventIds = []) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/shift-logs/downtime-comments`, {
      params: { eventIds },
      paramsSerializer: buildArrayParamSerializer,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching downtime comments:", error.response?.data || error);
    throw error;
  }
};
